import { Link } from "react-router-dom";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

const VALUES = [
  { icon: "ri-compass-3-line", title: "定位", desc: "聚合最新最全的影视资源，做影视爱好者发现好片的第一站。" },
  { icon: "ri-heart-2-line", title: "宗旨", desc: "免费、高清、分类清晰，让浏览影视内容变得简单而愉悦。" },
  { icon: "ri-shield-check-line", title: "原则", desc: "尊重原创与版权，本站内容均为虚构演示数据，不提供真实播放。" },
];

export default function AboutPage() {
  useDocumentMeta(
    "关于我们 - 免费播放片大片",
    "了解免费播放片大片的网站定位、服务宗旨、联系方式以及版权与免责声明，一个聚合电影与电视剧资源的影视内容平台。",
    "关于免费播放片大片,影视平台介绍,联系方式,版权声明,免责声明",
  );

  return (
    <div className="mx-auto w-full max-w-5xl px-4 py-10 md:px-8 md:py-14">
      <nav aria-label="面包屑" className="mb-4 flex items-center gap-1.5 text-sm text-foreground-400">
        <Link to="/" className="transition-colors hover:text-accent-400">
          首页
        </Link>
        <i className="ri-arrow-right-s-line"></i>
        <span className="text-foreground-200">关于</span>
      </nav>

      <header className="rounded-lg border border-background-800 bg-background-900/50 p-6 md:p-10">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/15 px-3 py-1 text-sm font-medium text-accent-400">
          <i className="ri-information-line"></i>
          关于我们
        </span>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-50 md:text-4xl">免费播放片大片</h1>
        <p className="mt-4 text-sm leading-relaxed text-foreground-300 md:text-base">
          免费播放片大片是一个面向影视爱好者的综合影视内容平台，聚合最新、最全的电影与电视剧资源，涵盖动作、喜剧、爱情、
          科幻、悬疑、剧情等多种类型。我们希望用清晰的信息结构、便捷的筛选方式与舒适的多端体验，帮助你快速找到并了解
          感兴趣的影视作品。
        </p>
      </header>

      <section className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3" aria-label="网站价值">
        {VALUES.map((value) => (
          <div key={value.title} className="rounded-lg border border-background-800 bg-background-900/50 p-5">
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/15 text-accent-400">
              <i className={`${value.icon} text-xl`}></i>
            </span>
            <h2 className="mt-3 font-heading text-base font-semibold text-foreground-50">{value.title}</h2>
            <p className="mt-1.5 text-sm leading-relaxed text-foreground-400">{value.desc}</p>
          </div>
        ))}
      </section>

      <section className="mt-8 rounded-lg border border-background-800 bg-background-900/50 p-6 md:p-8" aria-label="联系方式">
        <h2 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-50 md:text-xl">
          <i className="ri-customer-service-2-line text-accent-400"></i>
          联系方式
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-300">
          如对本站内容有任何建议、反馈或合作意向，欢迎通过以下方式与我们取得联系。以下邮箱为演示用途的虚构地址。
        </p>
        <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
          <div className="flex items-center gap-3 rounded-md bg-background-950/60 p-4">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500/15 text-accent-400">
              <i className="ri-mail-line text-lg"></i>
            </span>
            <div>
              <p className="text-xs text-foreground-500">客服邮箱</p>
              <p className="text-sm text-foreground-100">support@fpfp-demo.example</p>
            </div>
          </div>
          <div className="flex items-center gap-3 rounded-md bg-background-950/60 p-4">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500/15 text-accent-400">
              <i className="ri-time-line text-lg"></i>
            </span>
            <div>
              <p className="text-xs text-foreground-500">服务时间</p>
              <p className="text-sm text-foreground-100">周一至周五 10:00 - 18:00</p>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-8 space-y-6" aria-label="声明">
        <div className="rounded-lg border border-background-800 bg-background-900/50 p-6 md:p-8">
          <h2 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-50">
            <i className="ri-copyright-line text-accent-400"></i>
            版权声明
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-300">
            本站所有影视名称、剧情简介、演职人员及配图均为虚构示例数据，仅用于产品演示与界面展示，与任何真实作品、机构或个人
            无关。站内使用的示意图片均通过程序化方式生成，不涉及第三方影视素材。
          </p>
        </div>

        <div className="rounded-lg border border-background-800 bg-background-900/50 p-6 md:p-8">
          <h2 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-50">
            <i className="ri-error-warning-line text-accent-400"></i>
            免责声明
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-300">
            本站为演示性质的内容平台，不提供任何真实的在线播放、下载与传播服务，站内“观看”入口仅为交互展示，点击将提示功能
            尚未开放。用户在使用本站过程中产生的任何行为，均与本站无关。
          </p>
        </div>
      </section>

      <div className="mt-8 flex flex-wrap gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-950 whitespace-nowrap transition-colors hover:bg-accent-400"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/movie"
          className="inline-flex items-center gap-2 rounded-md border border-background-600 px-5 py-2.5 text-sm font-medium text-foreground-100 whitespace-nowrap transition-colors hover:border-accent-400 hover:text-accent-400"
        >
          <i className="ri-film-line"></i>
          浏览电影频道
        </Link>
      </div>
    </div>
  );
}